import { createContext, useContext } from 'react';
import { getToken } from '../user';
import { ProcessEnv } from '../types';

export interface UserConfig {
    error: {
        global: string;
    };
}

export interface IConfig {
    nodeEnv: string;
    appId: string;
    backendBaseUrl: string;
    apiKey: string;
    semrushJwt: string;
    error: {
        global: string;
    };
}

export function getConfig(env: ProcessEnv, conf: UserConfig): IConfig {
    if (!env.REACT_APP_ID) {
        throw new Error('No APP_ID provided.');
    }

    if (!env.REACT_APP_API_KEY) {
        throw new Error('No API key provided.');
    }

    if (!env.REACT_APP_BACKEND_URL) {
        throw new Error('Cannot connect to backend. No backend URL provided.');
    }

    const token = getToken(window);

    const semrushJwt = token ? token : env.REACT_APP_JWT_DEV;

    if (!semrushJwt && window.name !== 'semrush_iframe') {
        throw new Error('Cannot find user token, No JWT provided.');
    }

    return {
        nodeEnv: env.NODE_ENV,
        appId: env.REACT_APP_ID,
        semrushJwt: semrushJwt ?? '',
        backendBaseUrl: env.REACT_APP_BACKEND_URL,
        apiKey: env.REACT_APP_API_KEY,
        ...conf,
    };
}

export const Config = createContext<IConfig>({
    nodeEnv: '',
    appId: '',
    backendBaseUrl: '',
    apiKey: '',
    semrushJwt: '',
    error: {
        global: '',
    },
});

export function useConfig() {
    return useContext(Config);
}
